import { FunctionComponent } from "react";

interface SocialButtonsProps {}

const SocialButtons: FunctionComponent<SocialButtonsProps> = () => {
  return (
    <>
      <div className="icons">
        <a href="https://www.instagram.com/dieselconstructora/" target="_blank" ><i className="fa fa-linkedin-square" aria-hidden="true"></i></a>
        <a href="https://www.instagram.com/dieselconstructora/" target="_blank" ><i className="fa fa-instagram" aria-hidden="true"></i></a>
        <a href="https://www.instagram.com/dieselconstructora/" target="_blank" ><i className="fa fa-facebook-square" aria-hidden="true"></i></a>
      </div>
    </>
  );
};

export default SocialButtons;
